import { IconPack } from "Explore/Config/Icons";
import styles from "./KeywordCardInfo.module.scss";
import { Grid, IconButton } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { numberRegex } from "Explore/Utils/numberRegex";
import classNames from "classnames";

const KeywordCardInfo = ({ data, onClick, className, isSelected }) => {
  const statistics = [
    { icon: IconPack.h_index, label: "h-index", key: "h_index" },
    { icon: IconPack.i10_index, label: "i10-index", key: "i10_index" },
    { icon: IconPack.citation, label: "Citations", key: "citation_count" },
    {
      icon: IconPack.publications,
      label: "Publications",
      key: "publication_count",
    },
  ];
  return (
    <div
      className={classNames(styles["container"], className, {
        [styles["selected"]]: isSelected,
      })}
      {...(!!onClick
        ? {
            onClick: () =>
              onClick?.({
                ...data,
                name: data.keyword,
                value: data.keyword,
              }),
            style: {
              cursor: "pointer",
            },
          }
        : {})}
    >
      <div className={styles["concept-wrapper"]}>
        <p className={styles["concept"]}>{data.keyword}</p>
        <IconButton
          size="large"
          href={`/explore/concept/${data.id}`}
          className={styles["concept-link"]}
        >
          <LinkIcon />
        </IconButton>

        <div className={styles["ranking-wrapper"]}>
          <span className={styles["hash"]}>#</span>
          <span className={styles["ranking"]}>{data.rank}</span>&nbsp;
        </div>
      </div>
      <Grid container className={styles["statistics"]} spacing="8px">
        {statistics
          .filter((statistic) => !!data[statistic.key])
          .map((statistic, index) => (
            <Grid item xs={6} md={3} key={index}>
              <div className={styles["statistic"]}>
                {statistic.icon}
                <div className={styles["statistic__content"]}>
                  {/* <p className={styles["statistic__label"]}>
                    {statistic.label}
                  </p> */}
                  <p className={styles["statistic__value"]}>
                    {numberRegex(data[statistic.key])}
                  </p>
                </div>
              </div>
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

export default KeywordCardInfo;
